import React, { Component } from 'react';
import { Popconfirm, message, Button } from 'antd';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import Update from './Update';
import Filter from './Filter';

class NotBo extends Component {
    constructor(props) {
        super(props);
        const searchParams = {};
        this.state = {
            searchParams,
            curParams: {...searchParams},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            loading: false,
            data: [],
            areaList: [],
            directAreaList: [],  // 带教主管负责区域
        };
    }

    componentDidMount() {
        this.queryArea();
        this.loadData();
    }

    queryArea = () => {
        Fetch.post(API_URL.daily.queryarealist).then(res => {
            const { data } = res;
            const areaList = data.map(i => ({
                label: i.areaName,
                value: i.areaId,
                regions: i.regions,
            }));
            this.setState({ areaList });
        }).catch(err => {
            console.error(err);
        });
    }

    loadData = () => {
        const { curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const params = this.splitParams(curParams);
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.queryTeachLeaderList, {
            offset: current,
            limit: pageSize,
            ...params,
        }).then(res => {
            const { data, datas, totalCount } = res;
            const { supervisorList: directAreaList } = data;
            pagination.total = totalCount;
            this.setState({
                directAreaList,
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    delete = (teachLeaderId) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.delTeachLeader, {
            teachLeaderId
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                loading: false,
            }, () => {
                this.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { searchParams, pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { curParams } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.teaching.exportTeachLeaderList;
        ExportUtil.export({ ...params }, null, url);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { directAreaList } = this.state;
        const canOperate = !!(directAreaList || []).length;
        const columns = [{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 120,
        }, {
            title: '区域带教主管工号',
            dataIndex: 'supervisorCode',
            key: 'supervisorCode',
            width: 120,
        }, {
            title: '区域带教主管姓名',
            dataIndex: 'supervisorName',
            key: 'supervisorName',
            width: 120,
        }, {
            title: '带教组长工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
        }, {
            title: '带教组长姓名',
            dataIndex: 'userName',
            key: 'userName',
            width: 120,
        }, {
            title: '分管省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
        }];
        if (canOperate) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record) => {
                    const { canEdit, teachLeaderId } = record;
                    return (
                        canEdit ?
                            <span>
                                <a onClick={() => this.update(record, 'edit')}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除此带教组长?" onConfirm={() => this.delete(teachLeaderId)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        :
                            '-'
                    );
                }
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    render() {
        const { data, loading, pagination, searchParams, directAreaList, areaList } = this.state;
        const canOperate = !!(directAreaList || []).length;
        return (
            <div className="main">
                <Filter
                    search={this.search}
                    params={searchParams}
                    areaList={areaList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                        canOperate && <Button key="update" type="primary" onClick={() => this.update({}, 'add')}>添加带教组长</Button>
                    ]}
                />
                <TableC
                    loading={loading}
                    columns={this.getColumns()}
                    data={data}
                    pagination={pagination}
                    rowKey="director"
                    onChange={this.handleTableChange}
                />
                <Update ref={el => this.updateRef = el} directAreaList={directAreaList} areaList={areaList} loadData={this.loadData} />
            </div>
        );
    }
}

export default NotBo;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/NotBo.js